<template>
  <div
    class="space-y-2 md:flex @md/modal:flex md:flex-row @md/modal:flex-row md:space-y-0 @md/modal:space-y-0 py-5"

    :dusk="field.attribute"
  >
    <div
      class="w-full px-6 md:mt-2 @md/modal:mt-2 md:px-8 @md/modal:px-8 md:w-1/5 @md/modal:w-1/5"
    >
      <slot>
        <h4 class="font-normal @sm/peekable:break-all space-x-1">
          <span>{{ label }}</span>
            <span v-if="field.required" class="text-red-500 text-sm">
            {{ __('*') }}
          </span>
        </h4>
      </slot>
    </div>
    <div
      class="w-full space-y-2 px-6 md:px-8 @md/modal:px-8 md:w-3/3 @md/modal:w-3/5"

    >
      <slot name="value">
        <CopyButton
          v-if="fieldValue && field.copyable && !shouldDisplayAsHtml"
          @click.prevent.stop="copy"
          v-tooltip="__('Copy to clipboard')"
        >
          <span ref="theFieldValue">
            {{ fieldValue }}
          </span>
        </CopyButton>

        <p
          v-else-if="fieldValue && !field.copyable && !shouldDisplayAsHtml"
          class="flex items-center"
        >
          {{ fieldValue }}
        </p>
        <div
          v-else-if="fieldValue && !field.copyable && shouldDisplayAsHtml"
          v-html="fieldValue"
        />
        <p v-else>&mdash;</p>
      </slot>
    </div>
  </div>
</template>

<script>
import { CopiesToClipboard, FieldValue } from '@/mixins'

export default {
  mixins: [CopiesToClipboard, FieldValue],

  props: {
    index: {
      type: Number,
      required: true,
    },

    field: {
      type: Object,
      required: true,
    },

    fieldName: {
      type: String,
      default: '',
    },
  },

  methods: {
    copy() {
      this.copyValueToClipboard(this.field.value)
    },
  },

  computed: {
    label() {
      return this.fieldName || this.field.name
    },
  },
}
</script>
